module.exports = __webpack_public_path__ + "img/security.b1cad905.svg";